// JS shim to expose TS exports for legacy imports
module.exports = require('./LightOverride.ts');
